import { useEffect, useState } from 'react';

// Minimal data-loading hook: { data, loading, error }
export function useAsync(fn, deps) {
  const [state, setState] = useState({ data: undefined, loading: true, error: null });
  useEffect(() => {
    let cancelled = false;
    setState({ data: undefined, loading: true, error: null });
    fn().then(
      (data) => !cancelled && setState({ data, loading: false, error: null }),
      (error) => !cancelled && setState({ data: undefined, loading: false, error })
    );
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
}
